import React from "react";
import locale from "../../locale";

function DateBlock({date, items, footerLink})
{
	return (
		<div className={`date-block`}>
			<div className={`date-title`}>{date}</div>
			{items.map((item, index) =>
				<div className={`block-item`} key={index}>
					<div className={`block-item-date`}>{item.date}</div>
					<div className={`block-item-description`}>{locale.getProperty(item, 'description')}</div>
				</div>
			)}
			{footerLink ?
				<div className={`block-footer`}>
					<a href={footerLink.href} target="_blank" className={`block-footer-link`}>
						{locale.getProperty(footerLink, 'title')}
					</a>
				</div>
				: null
			}
		</div>
	);
}

class LayoutCustomScheduleBlocks extends React.Component
{
	render()
	{
		const {settings} = this.props;

		const title = locale.getProperty(settings, 'title');

		return (
			<aside className={`section-custom-schedule-blocks`} id={`custom-schedule-blocks`}>
				{title ? <h1 style={settings.styleHeader}>{title}</h1>: null}
				<div className="landing-nav-section-text">
					{settings.source.map((dateBlock, index) =>
						<DateBlock {...dateBlock} key={`block_${index}`} />
					)}
				</div>
			</aside>
		);
	}
}

export default LayoutCustomScheduleBlocks;
